<template>
	<div class="d-sm-flex justify-content-between my-4 pb-4 border-bottom">
		<div class="media d-block d-sm-flex text-center text-sm-left">
			<div class="custom-control custom-checkbox">
				<input class="custom-control-input" type="checkbox" :id="getCheckboxId(product.id)" :checked="product.checked === true" v-on:change="setChecked(product.id)">
				<label class="custom-control-label" :for="getCheckboxId(product.id)"></label>
			</div>
			<a class="cart-item-thumb mx-auto mr-sm-4" :href="product.url">
				<img :src="product.photo" :alt="product.productName">
			</a>
			<div class="media-body pt-3">
				<h3 class="product-card-title font-weight-semibold border-0 pb-0">
					<a :href="product.url">{{product.productName}}</a>
				</h3>
				<div class="font-size-sm"><span class="text-muted mr-2">Артикул:</span>{{product.code}}</div>
				<div class="font-size-lg text-primary pt-2">{{product.price}} ₽</div>
			</div>
		</div>
		<div class="d-flex justify-content-end align-items-center">
			<div>
				<div class="pt-2 pt-sm-0 pl-sm-3 mx-auto mx-sm-0 text-center text-sm-left" style="max-width: 10rem;" v-if="showEditField">
					<div class="form-group mb-2">
						<label for="quantity1">Количество</label>
						<input class="form-control form-control-sm" type="number" id="quantity1" v-model="count">
					</div>
					<button class="btn btn-outline-secondary btn-sm btn-block mb-2" type="button" v-on:click="update(product.id)"><i class="mr-1" data-feather="refresh-cw"></i>Обновить</button>
				</div>
				<div class="pt-2 pl-sm-3 mx-auto mx-sm-0 text-center text-sm-left" style="max-width: 10rem;" v-else>
					<div class="font-size-sm mb-3"><span class="text-muted mr-2">Количество:</span><span class="font-weight-semibold">{{count}}</span></div>
					<button class="btn btn-outline-secondary btn-sm btn-block mb-2" type="button" v-on:click="showEditFields"><i class="mr-1" data-feather="edit-2"></i>Изменить</button>
				</div>
			</div>
			<div class="ml-5" v-if="showEditField">
				<span class="item-remove-btn" v-on:click="removeProductFromCart(product.id)">
					<i class="fa fa-times" data-toggle="tooltip" data-placement="top" title="Удалить"></i>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	import { actions, namespace } from "Cart/store/store";
	import { mapActions } from "vuex";

	export default {
		name: "cart-item",
		data() {
			return {
				count: 1,
				showEditField: this.isEditVisible
			};
		},
		props: {
			product: Object,
			editVisibleAlways: Boolean,
			isEditVisible: Boolean
		},
		methods: {
			...mapActions(namespace, {
				removeProductFromCart: actions.removeProductFromCart.name,
				updateProductCount: actions.updateProductCount.name,
				setProductChecked: actions.setProductChecked.name,
				resetProductChecked: actions.resetProductChecked.name
			}),
			update(id) {
				this.updateProductCount({ id: id, count: this.count });
				if (!this.editVisibleAlways)
					this.showEditField = false;
			},
			showEditFields() {
				this.showEditField = true;
			},
			getCheckboxId(id) {
				return `check-${id}`;
			},
			setChecked(id) {
				let ch = document.getElementById(`check-${id}`).checked === true;

				if (ch)	this.setProductChecked(id);
				else this.resetProductChecked(id);
			}
		},
		created() {
			this.count = this.product.count;
		}
	}
</script>